import $ from "jquery";

$(document).ready(function () {
  var known = { en: true, de: true, es: true, fr: true, nl: true };
  var lang = (
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    navigator.userLanguage ||
    "en"
  ).substr(0, 2);
  if (!known[lang]) lang = "en";

  // Find all <div>s with a class of "wrapper" and lang attribute equal
  // to `lang` and make them visibile.
  $("div.wrapper[lang=" + lang + "]").show();

  // Find all <div>s with a class of "wrapper" and lang attribute not
  // equal to `lang` and make them invisibile.
  $("div.wrapper[lang!=" + lang + "]").hide();
});
